import emojis from '../../theme/emoji';

export const shoppingMobile = {
  securite: {
    name: 'Sécurité',
    emoji: emojis['Shield']
  },
  orgueil: {
    name: 'Orgueil',
    emoji: emojis['FaceMonocle']
  },
  nouveaute: {
    name: 'Nouveauté',
    emoji: emojis['NewButton']
  },
  confort: {
    name: 'Confort',
    emoji: emojis['RevieledFace']
  },
  argent: {
    name: 'Argent',
    emoji: emojis['MoneyBag']
  },
  sympathie: {
    name: 'Sympathie',
    emoji: emojis['RedHeart']
  },
  ecologie: {
    name: 'Écologie',
    emoji: emojis['Tree']
  }
};
